<template>
  <div class="mj_page">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane class="pane_item" label="Runway" name="runway">
        <runway  v-if="activeName=='runway'"></runway>
      </el-tab-pane>
      <el-tab-pane class="pane_item" label="Sora 2" name="sora">
        <sora  v-if="activeName=='sora'"></sora>
      </el-tab-pane>
      <el-tab-pane class="pane_item" label="Pika" name="pika">
        <pika  v-if="activeName=='pika'"></pika>
      </el-tab-pane>
      <el-tab-pane class="pane_item" label="Luma" name="luma">
        <luma v-if="activeName=='luma'"></luma>
      </el-tab-pane>
      <el-tab-pane class="pane_item" label="Viggle" name="viggle">
        <viggle v-if="activeName=='viggle'"></viggle>
      </el-tab-pane>
      <el-tab-pane class="pane_item" label="Ai换脸" name="face">
        <face v-if="activeName=='face'"></face>
      </el-tab-pane>
      <el-tab-pane class="pane_item" label="风格转换" name="anime">
        <anime v-if="activeName=='anime'"></anime>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import runway from "COMPONENTS/runway/index.vue"
import sora from "COMPONENTS/sora/index.vue"
import pika from "COMPONENTS/pika/index.vue"
import luma from "COMPONENTS/luma/index.vue"
import viggle from "COMPONENTS/viggle/index.vue"
import face from "COMPONENTS/face/index.vue"
import anime from "COMPONENTS/anime/index.vue"


export default {
  components: {runway,sora,pika,viggle,face,luma,anime},
  data() {
    return {
      activeName: "runway",
      // activeName: "viggle",
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  created() {
    // console.log('路由地址')
    // console.log(this.$route)
    if (this.$route.path === '/Anime') {
      this.activeName= "anime"
    }else if (this.$route.path === '/Face') {
      this.activeName= "face"
    }
  },
  methods: {
    handleTabClick(tab, event) {
      // console.log('点击了标签：', tab.name); // tab.name 就是 el-tab-pane 的 name
      if(tab.name == "anime"){
        this.$router.push('/Anime')
      }else if(tab.name == "face"){
        this.$router.push('/Face')
      }
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mj_page {
  width: 100%;
  height: 100%;
  background: #313338;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-bottom: 45px;

  .el-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;

    :deep(.el-tabs__header) {
      margin-bottom: 0;

      .el-tabs__nav-scroll {
        //padding: 0 20px;
        //width: 100%;
        //display: flex;
        //justify-content: center;
      }

      .el-tabs__nav-wrap:after {
        background-color: #555 !important;
      }

      .el-tabs__active-bar {
        background-color: #5865f2 !important;
      }

      .el-tabs__item {
        color: #fff;

        &.is-active {
          font-weight: 700;
          color: #5865f2 !important;
        }
      }
    }

    :deep(.el-tabs__content) {
      flex: 1;
    }
  }

  .pane_item {
    height: 100%;
  }
}
</style>